<template>
    <div>
      <!-- {{type}} -->
        <!-- 循环题号和分数 -->
            <el-table  :data="tableData"  row-key="rowId" style="width:100%" >
            <el-table-column label="题序" prop="num" width="50"></el-table-column>
            <el-table-column label="题型" prop="type" width="90">
              <template slot-scope='scope'>

                <div v-if="'topic_type' in scope.row">

                  <div v-if="scope.row.topic_type == 'SingleChoice' || scope.row.topic_type == 'MultiChoice'">
                    <el-tooltip class="item" effect="dark" content="点击可单条切换题目类型" placement="top" >
                      <!-- 转多选题 -->
                      <el-button @click="change(2,scope.row)" type="text" v-if="scope.row.topic_type == 'SingleChoice'"> {{  formatTitle(scope.row.topic_type) }}</el-button>
                      <!-- 转单选题 -->
                      <el-button @click="change(1,scope.row)" type="text" v-else> {{  formatTitle(scope.row.topic_type) }}</el-button>

                    </el-tooltip>
                    
                  </div>
                  <div v-else> {{formatTitle(scope.row.topic_type)}} </div>

              </div>
              <div v-else>
                <span style="font-size: 15px;"> 批量设置</span>
              </div>
                
              </template>
            </el-table-column>
            <el-table-column label="分数" prop="score" >
                <template slot-scope='scope'>
                    <el-input v-model="scope.row.score" placeholder="请输入分数"  @change.native="changeScore(scope.row)" oninput="value=value.match(/^\d*\.?\d{0,3}$/)||''"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="operation" align='center' label="特殊规则" v-if="type == 'SingleChoice' || type == 'MultiChoice' || type == 'Judge'  " >
                <template slot-scope="{ row, $index }">
                    <el-button type="primary" size="mini" @click.stop='specialValue(row)' v-if="$index !== 0 && row.topic_type == 'MultiChoice'">规则</el-button>
                </template>
            </el-table-column>

            </el-table>


                
      <!-- 特殊规则设置 -->
      <topicSpecialDialog ref="topicSpecialDialog" :topicSpecial="selTopic" @ok="setScoreRule"></topicSpecialDialog>



    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import * as simpleApi from "request/simple";
import XEUtils from 'xe-utils'
import * as mUtils from '@/utils/mUtils'
import topicSpecialDialog from "./topicSpecialDialog";
import answerHistory from "./answerHistory";
import { select } from "underscore";


    export default {
        name: 'newExamTopicLayoutDialog',
        data(){
            return {
              
                myTitle: '分数设置', 
                dialogVisible:false, 
                loading: false,
                zgInfo: null,
                list: [],
                selectedLetters: [], // 已选中的字母
                // 批量设置分数列表/特殊规则
                scoreList: [],
                activeNames:[],
                // 总表数据
                totalTopicList:[],
                tableData: [],
                groupId: null,
                selTopic: null, 
            }
        },
        components:{
          topicSpecialDialog
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),

        },
        
      	mounted() {

	    },
        props: {
          data: {
            type: Object,
            required: true
          },
          type: {
            type: String,
            required: true
          },
          groupId: {
            type: String,
            required: true
          },
        },
        watch: {
          // 监听 item 变化，重新生成表格数据
          data: {
            handler(newVal) {
              debugger
              // this.topicTableByCount(newVal);
              // debugger
              // let item = [
              //   {score: 0, groupId: this.groupId}
              // ]
              
              this.tableData = newVal
            },
            deep: true,
            immediate: true
          }
        },
        created() {
          
        },
        methods: {
            // 转换题型名称
            formatTitle(topicType){
                let map = {
                    'SingleChoice': '单选题',
                    'MultiChoice': '多选题',
                    'Judge': '判断题',
                    'FillBlank': '填空题',
                    'AnswerQuestion': '解答题',
                    'EnglishComposition': '英语作文',
                    'Composition': '语文作文',
                }
                return map[topicType] || topicType
            },
            specialValue(row){
              this.$emit('getSpecialData', row, (res) => {
                console.log('父组件返回的值：', res)
                this.specialMark(res)
              })
            },
            // 特殊规则
            specialMark(row){
              debugger
              this.selTopic = row;
              this.$refs.topicSpecialDialog.showDialog();
              // 强制删掉遮罩(非常诡异的会出现遮罩层)
              setTimeout(() => {
                const modal = document.querySelector('.v-modal');
                if (modal) modal.remove();
              }, 10);
            },
            setScoreRule(topicSpecialForm){
              debugger
              let scoreRules = topicSpecialForm.scoreRules
              this.$emit('setScoreRules',scoreRules, this.selTopic)
              // 保存进
                // let ar = XEUtils.find(this.kgData, item => {
                //     return item.topic_index == topicSpecialForm.topicIndex;
                // });
                // this.selTopic = null;
                // if(ar){
                //   if(topicSpecialForm.scoreRules != null){
                //     ar.score_rules = JSON.stringify(topicSpecialForm.scoreRules);
                //     console.log("setScoreRule2", ar);
                //   }else{
                //     ar.score_rules = null;
                //   }
                //     this.$set(this, "kgData", this.kgData);
                // }

            },
            // 批量设置分数
            changeScore(value){
              let score = value.score
              let groupId = value.groupId
              // 判断是不是批量修改成绩
              if( !( "rowId" in value)){
                this.tableData.forEach(item => {
                    item.score = score
                });
              }
              // 统计下总分，把总分传送给父组件的scoreList
              let list = this.tableData
              this.$emit("updateScoreList",groupId,list)
            },
            // 单条切换题目类型
            change(type,item){
              this.$emit("changeTopicType",type,item)
            },

        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
 .container {
    display: flex;
    // flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
    padding: 20px;
    justify-content: flex-start;
 }

/* 水平布局：左右排列 */
.card-horizontal {
//   display: flex;
  display: inline-flex;  /* 改为 inline-flex */
  // 外边距
//   gap: 5px;
  align-items: center;
}

/* 垂直布局：上下排列 */
.card-vertical {
  display: flex;
  flex-direction: column;
  // 行间隔
  gap: 5px;
  border: 1px;
//   margin-left: 20px;
}
.break {
  flex: 0 0 100%;  /* 占满整行 */
  border: none;
  height: 0;
  margin: 0;
  padding: 0;
  visibility: hidden;  /* 隐藏但占据空间 */
}
/* 换行元素 - 占满整行，强制换行 */
/* 关键：break-line 占满整行 */
.break-line {
  width: 100%;        /* 占满整行 */
  height: 1px;       /* 给点高度才能看到 */
  text-align: center;
//   margin: 10px 0;
  background-color: #e5e5e5; /* 这就是横线 */
}


.letter-container {
  display: flex;
  flex-wrap: wrap;
  // 选项间隔
  gap: 5px;
  padding-left: 5px;
//   padding: 5px;
}
.letter-item {
  // 选项高宽
  width: 20px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  cursor: pointer;
  border-radius: 3px;
}
.letter-item.active {
  background-color: #0066ff;
  color: #fff;
}




</style>


